import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { Alert, CircularProgress } from "@mui/material";
import DashboardClientLayout from "../../Layouts/DashboardClientLayout";
import { apiUrl } from "../../Constants";
import { hideLoader, showLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import passengerApi from "Services/Passenger";
import rideApi from "Services/Ride";
import "./FavorisPage.css";
import voiture1 from "../../assets/images/voiture1.png";
import voiture2 from "../../assets/images/voiture2.png";
import voiture3 from "../../assets/images/voiture3.png";
import camry2020 from "../../assets/images/classique.png";
import hyundai2020 from "../../assets/images/premium.png";
import kiaCarnival2020 from "../../assets/images/gold.png";
import generalVoyage from "../../assets/images/general-voyage.jpg";
import fitnessVoyage from "../../assets/images/fitness-voyage.jpeg";

const TAB_KEYS = [
  { key: "all", messageId: "dashboard.favorites.tabs.all", icon: "heart" },
  { key: "trips", messageId: "dashboard.favorites.tabs.trips", icon: "car" },
  { key: "vehicles", messageId: "dashboard.favorites.tabs.vehicles", icon: "bus" },
  { key: "places", messageId: "dashboard.favorites.tabs.places", icon: "pin" },
];

const QUICK_LINK_KEYS = [
  { key: "history", titleId: "dashboard.favorites.quickLinks.history.title", descId: "dashboard.favorites.quickLinks.history.desc", icon: "history" },
  { key: "wallet", titleId: "dashboard.favorites.quickLinks.wallet.title", descId: "dashboard.favorites.quickLinks.wallet.desc", icon: "wallet" },
  { key: "payments", titleId: "dashboard.favorites.quickLinks.payments.title", descId: "dashboard.favorites.quickLinks.payments.desc", icon: "card" },
];

const suggestions = [
  { title: "Douala → Yaounde", subtitle: "Covoiturage", icon: "car", image: voiture1 },
  { title: "Bafoussam → Yaounde", subtitle: "Bus", icon: "bus", image: voiture2 },
  { title: "Douala → Garoua", subtitle: "Train", icon: "train", image: voiture3 },
];

function SearchIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="11" cy="11" r="7.5" />
      <path d="m16.5 16.5 4.5 4.5" />
    </svg>
  );
}

function FilterIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 6h16l-6 7v5l-4 2v-7L4 6Z" />
    </svg>
  );
}

function MoreIcon() {
  return (
    <span className="fc-more-icon" aria-hidden="true">
      <span />
      <span />
      <span />
    </span>
  );
}

function HeartIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 21s-7-4.7-9-9.2A5.5 5.5 0 0 1 12 5.8a5.5 5.5 0 0 1 9 6C19 16.3 12 21 12 21Z" />
    </svg>
  );
}

function BusIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="5" width="14" height="13" rx="3" />
      <path d="M8 9h8M8 12h8M9 18v1M15 18v1" />
    </svg>
  );
}

function TrainIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7 4h10a3 3 0 0 1 3 3v7a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V7a3 3 0 0 1 3-3Z" />
      <path d="M8 9h8M8 12h8M9 18v1M15 18v1" />
    </svg>
  );
}

function PinIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 21s5-5.6 5-10.5A5 5 0 0 0 7 10.5C7 15.4 12 21 12 21Z" />
      <circle cx="12" cy="10.5" r="2" />
    </svg>
  );
}

function CardIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="6" width="16" height="12" rx="2.5" />
      <path d="M4 10h16" />
    </svg>
  );
}

function HistoryIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5v5l3 2" />
    </svg>
  );
}

function WalletIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 8.5A2.5 2.5 0 0 1 6.5 6h11A2.5 2.5 0 0 1 20 8.5V17a2 2 0 0 1-2 2H6.5A2.5 2.5 0 0 1 4 16.5v-8Z" />
      <path d="M15.5 12.5h4" />
    </svg>
  );
}

function BookmarkIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7 4.5h10a1 1 0 0 1 1 1v14l-6-3-6 3v-14a1 1 0 0 1 1-1Z" />
    </svg>
  );
}

function CarFrontIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 13.5 6.4 9.8A2.7 2.7 0 0 1 9 8h6a2.7 2.7 0 0 1 2.6 1.8l1.4 3.7" />
      <path d="M4 13.5h16V17H4z" />
      <circle cx="8" cy="16.8" r="1.2" />
      <circle cx="16" cy="16.8" r="1.2" />
    </svg>
  );
}

function SidebarGlyph({ icon }) {
  if (icon === "car") return <CarFrontIcon />;
  if (icon === "bus") return <BusIcon />;
  if (icon === "train") return <TrainIcon />;
  if (icon === "pin") return <PinIcon />;
  if (icon === "history") return <HistoryIcon />;
  if (icon === "wallet") return <WalletIcon />;
  if (icon === "card") return <CardIcon />;
  if (icon === "bookmark") return <BookmarkIcon />;
  return <HeartIcon />;
}

function SummaryTile({ value, label, icon, tone }) {
  return (
    <div className="fc-summary-tile">
      <span className={`fc-summary-tile-icon ${tone}`}>
        <SidebarGlyph icon={icon} />
      </span>
      <div className="fc-summary-tile-copy">
        <strong>{value}</strong>
        <span>{label}</span>
      </div>
    </div>
  );
}

function TabButton({ tab, active, onClick }) {
  const intl = useIntl();
  return (
    <button type="button" className={`fc-tab ${active ? "is-active" : ""}`} onClick={onClick}>
      <span className="fc-tab-icon">
        <SidebarGlyph icon={tab.icon} />
      </span>
      <span>{intl.formatMessage({ id: tab.messageId })}</span>
    </button>
  );
}

function SectionHeader({ title, count, action }) {
  return (
    <div className="fc-section-head">
      <h2>{title}</h2>
      <div className="fc-section-meta">
        {count ? <span className="fc-count">{count}</span> : null}
        <a href="/">{action}</a>
      </div>
    </div>
  );
}

function TripCard({ item }) {
  const intl = useIntl();
  return (
    <article className="fc-trip-card">
      <div className={`fc-trip-thumb is-${item.accent}`}>
        <img src={item.image} alt="" aria-hidden="true" />
      </div>
      <div className="fc-trip-main">
        <strong>{item.title}</strong>
        <span>{item.subtitle}</span>
      </div>
      <div className="fc-trip-meta">
        <div className="fc-meta-block">
          <span className="fc-meta-icon">
            <HistoryIcon />
          </span>
          <strong>{item.time}</strong>
          <small>{intl.formatMessage({ id: "dashboard.favorites.card.time" })}</small>
        </div>
        <div className="fc-meta-block">
          <span className="fc-meta-icon">
            <PinIcon />
          </span>
          <strong>{item.from}</strong>
          <small>{intl.formatMessage({ id: "dashboard.favorites.card.origin" })}</small>
        </div>
        <div className="fc-meta-block">
          <span className="fc-meta-icon">
            <PinIcon />
          </span>
          <strong>{item.to}</strong>
          <small>{intl.formatMessage({ id: "dashboard.favorites.card.destination" })}</small>
        </div>
      </div>
      <button
        type="button"
        className="fc-like-btn"
        aria-label={intl.formatMessage({ id: "dashboard.favorites.card.removeFromFavorites" })}
      >
        <HeartIcon />
      </button>
      <button
        type="button"
        className="fc-more-btn"
        aria-label={intl.formatMessage({ id: "dashboard.favorites.card.moreOptions" })}
      >
        <MoreIcon />
      </button>
    </article>
  );
}

function VehicleCard({ item }) {
  const intl = useIntl();
  return (
    <article className="fc-vehicle-card">
      <div className={`fc-vehicle-photo is-${item.accent}`}>
        <img src={item.image} alt="" aria-hidden="true" />
      </div>
      <div className="fc-vehicle-content">
        <strong>{item.title}</strong>
        <span>{item.subtitle}</span>
        <small className="fc-vehicle-plate">{item.plate}</small>
      </div>
      <button
        type="button"
        className="fc-star-btn"
        aria-label={intl.formatMessage({ id: "dashboard.favorites.card.removeFromFavorites" })}
      >
        <HeartIcon />
      </button>
      <button
        type="button"
        className="fc-more-btn"
        aria-label={intl.formatMessage({ id: "dashboard.favorites.card.moreOptions" })}
      >
        <MoreIcon />
      </button>
    </article>
  );
}

function PlaceCard({ item }) {
  const intl = useIntl();
  return (
    <article className="fc-place-card">
      <div className={`fc-place-photo is-${item.accent}`}>
        <img src={item.image} alt="" aria-hidden="true" />
      </div>
      <div className="fc-place-content">
        <strong>{item.title}</strong>
        <span>{item.city}</span>
        <small>{item.tag}</small>
      </div>
      <button
        type="button"
        className="fc-star-btn"
        aria-label={intl.formatMessage({ id: "dashboard.favorites.card.removeFromFavorites" })}
      >
        <HeartIcon />
      </button>
      <button
        type="button"
        className="fc-more-btn"
        aria-label={intl.formatMessage({ id: "dashboard.favorites.card.moreOptions" })}
      >
        <MoreIcon />
      </button>
    </article>
  );
}

function SideAction({ item }) {
  return (
    <button type="button" className="fc-side-action">
      <span className="fc-side-action-icon">
        <SidebarGlyph icon={item.icon} />
      </span>
      <span className="fc-side-action-copy">
        <strong>{item.title}</strong>
        <small>{item.desc}</small>
      </span>
      <span className="fc-side-action-arrow">›</span>
    </button>
  );
}

function SuggestionRow({ item }) {
  const intl = useIntl();
  return (
    <div className="fc-suggestion-row">
      <span className="fc-suggestion-icon">
        <img src={item.image} alt="" aria-hidden="true" />
      </span>
      <div className="fc-suggestion-copy">
        <strong>{item.title}</strong>
        <small>{item.subtitle}</small>
      </div>
      <button
        type="button"
        className="fc-add-btn"
        aria-label={intl.formatMessage({ id: "dashboard.favorites.card.addToFavorites" }, { title: item.title })}
      >
        {intl.formatMessage({ id: "dashboard.favorites.card.add" })}
      </button>
    </div>
  );
}

const getRideTypeLabel = (rideType, intl) => {
  if (rideType === "bus") return intl.formatMessage({ id: "dashboard.favorites.rideType.bus" });
  if (rideType === "train") return intl.formatMessage({ id: "dashboard.favorites.rideType.train" });
  if (rideType === "livraison") return intl.formatMessage({ id: "dashboard.favorites.rideType.delivery" });
  if (rideType === "course") return intl.formatMessage({ id: "dashboard.favorites.rideType.ride" });
  return intl.formatMessage({ id: "dashboard.favorites.rideType.carpool" });
};

const getTripImage = (rideType, index) => {
  if (rideType === "bus") return voiture2;
  if (rideType === "train") return voiture3;
  if (rideType === "livraison") return voiture1;
  if (rideType === "course") return voiture2;
  return suggestions[index % suggestions.length]?.image || [voiture1, voiture2, voiture3][index % 3];
};

const resolveImageUrl = (path, fallback) => {
  if (!path) {
    return fallback;
  }

  if (typeof path === "string" && /^https?:\/\//i.test(path)) {
    return path;
  }

  return `${apiUrl}${path}`;
};

const normalizeLikedRide = (item, index, intl) => {
  const ride = item?.ride || {};
  const passenger = item?.passenger || {};
  const origin = ride?.places_rides_origin_place_idToplaces || {};
  const destination = ride?.places_rides_destination_place_idToplaces || {};
  const rideType = String(ride?.ride_type || "covoiturage").toLowerCase();
  const seatsBooked = item?.seats_booked ?? 1;

  return {
    id: item?.id || ride?.id || `liked-${index}`,
    title: `${origin?.name || intl.formatMessage({ id: "dashboard.favorites.defaults.trip" })} → ${destination?.name || intl.formatMessage({ id: "dashboard.favorites.defaults.trip" })}`,
    subtitle: intl.formatMessage(
      { id: "dashboard.favorites.rideSubtitle" },
      { rideType: getRideTypeLabel(rideType, intl), count: seatsBooked }
    ),
    time: ride?.departure_at ? new Date(ride.departure_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "--:--",
    from: origin?.addressLocality || origin?.name || "-",
    to: destination?.addressLocality || destination?.name || "-",
    rideType,
    amount: item?.total_amount,
    currency: item?.currency || "XAF",
    status: item?.status || "pending",
    likedAt: item?.liked_at || null,
    image: getTripImage(rideType, index),
    accent: rideType === "train" ? "violet" : rideType === "bus" ? "blue" : "green",
    passengerName: `${passenger?.first_name || ""} ${passenger?.last_name || ""}`.trim(),
    ride,
  };
};

const normalizeLikedVehicle = (item, index, intl) => {
  const ride = item?.ride || {};
  const origin = ride?.places_rides_origin_place_idToplaces || {};
  const destination = ride?.places_rides_destination_place_idToplaces || {};
  const vehicle = ride?.vehicles || {};
  const seats = vehicle?.seat || ride?.total_seats;

  return {
    id: item?.id || ride?.id || `liked-vehicle-${index}`,
    title: vehicle?.vehicle_name || vehicle?.vehicle_brand || intl.formatMessage({ id: "dashboard.favorites.defaults.vehicle" }),
    subtitle: intl.formatMessage(
      { id: "dashboard.favorites.vehicleSubtitle" },
      { color: vehicle?.vehicle_color || "-", seats: Number(seats) || 0 }
    ),
    plate: vehicle?.vehicle_no || vehicle?.vehicle_manufacturer || "--",
    accent: index % 3 === 0 ? "sand" : index % 3 === 1 ? "graphite" : "pearl",
    image: resolveImageUrl(vehicle?.vehicle_image, [camry2020, hyundai2020, kiaCarnival2020][index % 3]),
    rideType: String(ride?.ride_type || "covoiturage").toLowerCase(),
    originName: origin?.name || intl.formatMessage({ id: "dashboard.favorites.defaults.departure" }),
    destinationName: destination?.name || intl.formatMessage({ id: "dashboard.favorites.defaults.arrival" }),
  };
};

const normalizePlace = (item, index, intl) => ({
  id: item?.id || `place-${index}`,
  title: item?.title || item?.name || intl.formatMessage({ id: "dashboard.favorites.defaults.place" }),
  city: item?.city || item?.addressLocality || item?.addressCountry || "",
  tag: item?.tag || intl.formatMessage({ id: "dashboard.favorites.placeTag.origin" }),
  accent: index % 2 === 0 ? "station" : "station-alt",
  image: item?.image || (index % 2 === 0 ? generalVoyage : fitnessVoyage),
});

const getLikedPlaceTag = (type, intl) => {
  const normalizedType = String(type || "").trim().toLowerCase();
  if (normalizedType === "home") return intl.formatMessage({ id: "dashboard.favorites.placeTag.origin" });
  if (normalizedType === "work") return intl.formatMessage({ id: "dashboard.favorites.placeTag.destination" });
  return intl.formatMessage({ id: "dashboard.favorites.placeTag.origin" });
};

const normalizeLikedPlace = (item, index, intl) => {
  const place = item?.places || {};

  return {
    id: item?.id || item?.place_id || place?.id || `liked-place-${index}`,
    title: place?.name || item?.address || item?.type || intl.formatMessage({ id: "dashboard.favorites.defaults.place" }),
    city: place?.addressLocality || place?.addressCountry || item?.address || "",
    tag: getLikedPlaceTag(item?.type, intl),
    accent: index % 2 === 0 ? "station" : "station-alt",
    image: index % 2 === 0 ? generalVoyage : fitnessVoyage,
  };
};

const getFavoriteSuggestionTypeLabel = (ride = {}, intl) => {
  const rawType = String(
    ride?.ride_type ||
      ride?.type ||
      ride?.mode ||
      ride?.service_type ||
      ride?.service_type_id?.name ||
      ride?.service_type_id?.serviceName ||
      ride?.service?.name ||
      ""
  )
    .trim()
    .toLowerCase();

  if (rawType.includes("bus")) return intl.formatMessage({ id: "dashboard.favorites.rideType.bus" });
  if (rawType.includes("train")) return intl.formatMessage({ id: "dashboard.favorites.rideType.train" });
  if (rawType.includes("livraison") || rawType.includes("delivery")) return intl.formatMessage({ id: "dashboard.favorites.rideType.delivery" });
  if (rawType.includes("course") || rawType.includes("taxi")) return intl.formatMessage({ id: "dashboard.favorites.rideType.ride" });
  return intl.formatMessage({ id: "dashboard.favorites.rideType.carpool" });
};

const normalizeFavoriteSuggestion = (item, index, intl) => {
  const ride = item?.ride || item || {};
  const origin = ride?.places_rides_origin_place_idToplaces || ride?.origin_place || ride?.origin || item?.origin || {};
  const destination = ride?.places_rides_destination_place_idToplaces || ride?.destination_place || ride?.destination || item?.destination || {};
  const rideType = getFavoriteSuggestionTypeLabel(ride, intl);
  const originName = origin?.addressLocality || origin?.city || origin?.name || ride?.origin_place_name || intl.formatMessage({ id: "dashboard.favorites.defaults.departure" });
  const destinationName = destination?.addressLocality || destination?.city || destination?.name || ride?.destination_place_name || intl.formatMessage({ id: "dashboard.favorites.defaults.arrival" });

  return {
    id: item?.id || ride?.id || ride?.ride_id || `${originName}-${destinationName}-${index}`,
    title: `${originName} - ${destinationName}`,
    subtitle: rideType,
    image: getTripImage(rideType.toLowerCase(), index),
  };
};

export default function FavorisClient() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const authUser = useSelector((state) => state?.AuthReducer?.user || {});
  const passengerId = useSelector((state) => state?.AuthReducer?.userid || authUser?.id || localStorage.getItem("userid") || "");

  const [selectedTab, setSelectedTab] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [likedRides, setLikedRides] = useState([]);
  const [likedVehicles, setLikedVehicles] = useState([]);
  const [likedPlaces, setLikedPlaces] = useState([]);
  const [totalLikedRides, setTotalLikedRides] = useState(0);
  const [totalLikedVehicles, setTotalLikedVehicles] = useState(0);
  const [totalLikedPlaces, setTotalLikedPlaces] = useState(0);
  const [totalLiked, setTotalLiked] = useState(0);
  const [favoriteSuggestions, setFavoriteSuggestions] = useState([]);
  const [favoriteSuggestionsLoading, setFavoriteSuggestionsLoading] = useState(false);
  const [favoriteSuggestionsError, setFavoriteSuggestionsError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loadError, setLoadError] = useState("");

  const loadLiked = useCallback(async () => {
    if (!passengerId) {
      setLoadError(intl.formatMessage({ id: "dashboard.favorites.errors.noUserId" }));
      setLikedRides([]);
      setLikedVehicles([]);
      setLikedPlaces([]);
      setTotalLikedRides(0);
      setTotalLikedVehicles(0);
      setTotalLikedPlaces(0);
      setTotalLiked(0);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setLoadError("");
    dispatch(showLoader(intl.formatMessage({ id: "dashboard.favorites.loading" })));

    try {
      const res = await passengerApi.getLikedBookings({ id: passengerId });
      if (res?.data?.status === true) {
        const favoritesData = res?.data?.data || {};
        const likedRideList = Array.isArray(favoritesData?.liked_rides)
          ? favoritesData.liked_rides.map((item, index) => normalizeLikedRide(item, index, intl))
          : [];
        const vehicles = Array.isArray(favoritesData?.liked_vehicles)
          ? favoritesData.liked_vehicles.map((item, index) => normalizeLikedVehicle(item, index, intl))
          : [];
        const places = Array.isArray(favoritesData?.liked_places)
          ? favoritesData.liked_places.map((item, index) => normalizeLikedPlace(item, index, intl))
          : likedRideList
              .map((item, index) =>
                normalizePlace(
                  {
                    id: `${item.id}-origin`,
                    title: item.from,
                    city: item.from,
                    tag: intl.formatMessage({ id: "dashboard.favorites.placeTag.origin" }),
                    image: index % 2 === 0 ? generalVoyage : fitnessVoyage,
                  },
                  index,
                  intl
                )
              )
              .slice(0, 2);

        setLikedRides(likedRideList);
        setLikedVehicles(vehicles);
        setLikedPlaces(places);
        setTotalLikedRides(Number(favoritesData?.total_liked_rides ?? likedRideList.length ?? 0));
        setTotalLikedVehicles(Number(favoritesData?.total_liked_vehicles ?? vehicles.length ?? 0));
        setTotalLikedPlaces(Number(favoritesData?.total_liked_places ?? places.length ?? 0));
        setTotalLiked(Number(favoritesData?.total_liked ?? (likedRideList.length + vehicles.length + places.length)));
      } else {
        setLikedRides([]);
        setLikedVehicles([]);
        setLikedPlaces([]);
        setTotalLikedRides(0);
        setTotalLikedVehicles(0);
        setTotalLikedPlaces(0);
        setTotalLiked(0);
        setLoadError(res?.data?.message || intl.formatMessage({ id: "dashboard.favorites.errors.noneFound" }));
      }
    } catch (error) {
      setLikedRides([]);
      setLikedVehicles([]);
      setLikedPlaces([]);
      setTotalLikedRides(0);
      setTotalLikedVehicles(0);
      setTotalLikedPlaces(0);
      setTotalLiked(0);
      const message = error?.response?.data?.message || intl.formatMessage({ id: "dashboard.favorites.errors.loadFailed" });
      setLoadError(message);
      dispatch(
        showSnackbar({
          message,
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    } finally {
      setIsLoading(false);
      dispatch(hideLoader());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, passengerId, intl]);

  const loadFavoriteSuggestions = useCallback(async () => {
    if (!passengerId) {
      setFavoriteSuggestions([]);
      setFavoriteSuggestionsError("");
      setFavoriteSuggestionsLoading(false);
      return;
    }

    setFavoriteSuggestionsLoading(true);
    setFavoriteSuggestionsError("");

    try {
      const res = await rideApi.getFavoritePlaces({ id: passengerId, user_id: passengerId, userId: passengerId });
      const payload = res?.data?.data?.data ?? res?.data?.data ?? res?.data ?? {};
      const rides = Array.isArray(payload) ? payload : Array.isArray(payload?.rides) ? payload.rides : [];
      const normalizedSuggestions = rides.map((item, index) => normalizeFavoriteSuggestion(item, index, intl));

      if (res?.data?.status === false) {
        setFavoriteSuggestions([]);
        setFavoriteSuggestionsError(res?.data?.message || intl.formatMessage({ id: "dashboard.favorites.errors.noSuggestions" }));
        return;
      }

      setFavoriteSuggestions(normalizedSuggestions);
    } catch (error) {
      setFavoriteSuggestions([]);
      setFavoriteSuggestionsError(
        error?.response?.data?.message || intl.formatMessage({ id: "dashboard.favorites.errors.suggestionsLoadFailed" })
      );
    } finally {
      setFavoriteSuggestionsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [passengerId, intl]);

  useEffect(() => {
    loadLiked();
  }, [loadLiked]);

  useEffect(() => {
    loadFavoriteSuggestions();
  }, [loadFavoriteSuggestions]);

  const normalizedSearch = searchTerm.trim().toLowerCase();
  const filteredTrips = useMemo(
    () =>
      likedRides.filter((item) =>
        !normalizedSearch
          ? true
          : [item.title, item.subtitle, item.from, item.to, item.rideType, item.status]
              .join(" ")
              .toLowerCase()
              .includes(normalizedSearch)
      ),
    [likedRides, normalizedSearch]
  );
  const filteredVehicles = useMemo(
    () =>
      likedVehicles.filter((item) =>
        !normalizedSearch
          ? true
          : [item.title, item.subtitle, item.plate, item.originName, item.destinationName, item.rideType]
              .join(" ")
              .toLowerCase()
              .includes(normalizedSearch)
      ),
    [likedVehicles, normalizedSearch]
  );
  const filteredPlaces = useMemo(
    () =>
      likedPlaces.filter((item) =>
        !normalizedSearch
          ? true
          : [item.title, item.city, item.tag]
              .join(" ")
              .toLowerCase()
              .includes(normalizedSearch)
      ),
    [likedPlaces, normalizedSearch]
  );

  const visibleTrips = selectedTab === "vehicles" ? [] : selectedTab === "places" ? [] : filteredTrips;
  const visibleVehicles = selectedTab === "trips" ? [] : selectedTab === "places" ? [] : filteredVehicles;
  const visiblePlaces = selectedTab === "all" || selectedTab === "places" ? filteredPlaces : [];
  const visibleFavoriteSuggestions = useMemo(() => favoriteSuggestions.slice(0, 3), [favoriteSuggestions]);

  const totalFavorites = totalLiked || totalLikedRides + totalLikedVehicles + totalLikedPlaces;

  return (
    <>
      <div className="fc-hero">
        <div>
          <h1>{intl.formatMessage({ id: "dashboard.favorites.hero.title" })}</h1>
          <p>{intl.formatMessage({ id: "dashboard.favorites.hero.subtitle" })}</p>
        </div>
      </div>

      <div className="fc-toolbar">
        <div className="fc-tabs">
          {TAB_KEYS.map((tab) => (
            <TabButton key={tab.key} tab={tab} active={selectedTab === tab.key} onClick={() => setSelectedTab(tab.key)} />
          ))}
        </div>

        <div className="fc-actions">
          <label className="fc-search" aria-label={intl.formatMessage({ id: "dashboard.favorites.search.ariaLabel" })}>
            <SearchIcon />
            <input
              type="text"
              placeholder={intl.formatMessage({ id: "dashboard.favorites.search.placeholder" })}
              value={searchTerm}
              onChange={(event) => setSearchTerm(event.target.value)}
            />
          </label>
          <button type="button" className="fc-filter-btn" onClick={loadLiked}>
            <FilterIcon />
            <span>{intl.formatMessage({ id: "dashboard.favorites.refresh" })}</span>
          </button>
        </div>
      </div>

      {loadError ? (
        <Alert severity="error" sx={{ mt: 2 }}>
          {loadError}
        </Alert>
      ) : null}

      {isLoading ? (
        <div style={{ display: "grid", placeItems: "center", padding: "32px 0" }}>
          <CircularProgress />
        </div>
      ) : null}

      <div className="fc-layout">
        <section className="fc-main">
          <div className="fc-block">
            <SectionHeader
              title={intl.formatMessage({ id: "dashboard.favorites.sections.trips.title" })}
              count={intl.formatMessage({ id: "dashboard.favorites.sections.trips.count" }, { count: totalLikedRides })}
              action={intl.formatMessage({ id: "dashboard.favorites.sections.viewAll" })}
            />
            <div className="fc-trips-list">
              {visibleTrips.map((item) => (
                <TripCard key={item.id} item={item} />
              ))}
            </div>
          </div>

          <div className="fc-block">
            <SectionHeader
              title={intl.formatMessage({ id: "dashboard.favorites.sections.vehicles.title" })}
              count={intl.formatMessage({ id: "dashboard.favorites.sections.vehicles.count" }, { count: totalLikedVehicles })}
              action={intl.formatMessage({ id: "dashboard.favorites.sections.viewAll" })}
            />
            <div className="fc-vehicles-list">
              {visibleVehicles.map((item) => (
                <VehicleCard key={item.id} item={item} />
              ))}
            </div>
          </div>

          <div className="fc-block">
            <SectionHeader
              title={intl.formatMessage({ id: "dashboard.favorites.sections.places.title" })}
              count={intl.formatMessage({ id: "dashboard.favorites.sections.places.count" }, { count: totalLikedPlaces })}
              action={intl.formatMessage({ id: "dashboard.favorites.sections.viewAll" })}
            />
            <div className="fc-places-list">
              {visiblePlaces.map((item) => (
                <PlaceCard key={item.id} item={item} />
              ))}
            </div>
          </div>
        </section>

        <aside className="fc-sidebar">
          <article className="fc-summary-card">
            <div className="fc-summary-head">
              <h3>{intl.formatMessage({ id: "dashboard.favorites.summary.title" })}</h3>
              <span className="fc-summary-heart">
                <HeartIcon />
              </span>
            </div>
            <div className="fc-summary-grid">
              <SummaryTile
                value={totalFavorites}
                label={intl.formatMessage({ id: "dashboard.favorites.summary.total" })}
                icon="bookmark"
                tone="green"
              />
              <SummaryTile
                value={totalLikedRides}
                label={intl.formatMessage({ id: "dashboard.favorites.summary.trips" })}
                icon="car"
                tone="blue"
              />
              <SummaryTile
                value={totalLikedVehicles}
                label={intl.formatMessage({ id: "dashboard.favorites.summary.vehicles" })}
                icon="bus"
                tone="violet"
              />
              <SummaryTile
                value={totalLikedPlaces}
                label={intl.formatMessage({ id: "dashboard.favorites.summary.places" })}
                icon="pin"
                tone="orange"
              />
            </div>
          </article>

          <article className="fc-panel">
            <div className="fc-panel-head">
              <h3>{intl.formatMessage({ id: "dashboard.favorites.quickAccess.title" })}</h3>
            </div>
            <div className="fc-side-actions">
              {QUICK_LINK_KEYS.map((item) => (
                <SideAction
                  key={item.key}
                  item={{
                    title: intl.formatMessage({ id: item.titleId }),
                    desc: intl.formatMessage({ id: item.descId }),
                    icon: item.icon,
                  }}
                />
              ))}
            </div>
          </article>

          <article className="fc-panel">
            <div className="fc-panel-head">
              <h3>{intl.formatMessage({ id: "dashboard.favorites.suggestions.title" })}</h3>
            </div>
            {favoriteSuggestionsError ? (
              <Alert severity="warning" sx={{ mb: 1 }}>
                {favoriteSuggestionsError}
              </Alert>
            ) : null}

            {favoriteSuggestionsLoading ? (
              <div style={{ display: "grid", placeItems: "center", padding: "18px 0" }}>
                <CircularProgress size={22} />
              </div>
            ) : visibleFavoriteSuggestions.length ? (
              <div className="fc-suggestions">
                {visibleFavoriteSuggestions.map((item) => (
                  <SuggestionRow key={item.id} item={item} />
                ))}
              </div>
            ) : (
              <div className="fc-suggestions-empty">
                {intl.formatMessage({ id: "dashboard.favorites.suggestions.empty" })}
              </div>
            )}
            <button type="button" className="fc-more-suggestions">
              {intl.formatMessage({ id: "dashboard.favorites.suggestions.more" })}
            </button>
          </article>
        </aside>
      </div>
    </>
  );
}